module.exports = __webpack_public_path__ + "assets/animejs.b55ed937.svg";